import { useState } from "react";
import styles from '../Styles/SearchBar.css'

const SearchBar = ({imgTerm,setImgTerm}) => {

	const [timer, setTimer] = useState(null);

	function changeDelay(change) {
	    if (timer) {
	      clearTimeout(timer);
	      setTimer(null);
	    }
	    setTimer(
	      setTimeout(() => {
	        setImgTerm(change)
	      }, 350)
	    );
	}

	return(
			<div className = "searchBarWrapper">
				<input 
					type = "text" 
					placeholder = "Search for anything!"
					// value={imgTerm}
					onChange={(e) => { changeDelay(e.target.value); }}
				/>
			</div>
		)
}

export default SearchBar;